import React, { memo, SVGProps } from 'react'

export const MinusBold = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M16.7971 10.56H7.20288C6.408 10.56 5.76288 11.2051 5.76288 12C5.76288 12.7949 6.408 13.44 7.20288 13.44H16.7971C17.592 13.44 18.2371 12.7949 18.2371 12C18.2371 11.2051 17.592 10.56 16.7971 10.56Z"
      fill="currentColor"
    />
  </svg>
))
